import {Empty} from 'antd';
import React from 'react';

const QuestionAnswer = ({attributeSerials}) => {
  return (
    <div className='question-answer'>
      <div className='title'>MÃ SERIAL</div>
      <div>
        {attributeSerials?.length > 0 ? (
          attributeSerials
            .slice()
            .reverse()
            .map(
              attributeSerial =>
                attributeSerial.serials && (
                  <div className='serials' key={attributeSerial.size}>
                    <div className='size'>Size {attributeSerial.size}</div>
                    <div>
                      {attributeSerial.serials
                        .slice()
                        .sort((a, b) => a.localeCompare(b))
                        .map(serial => (
                          <p key={serial}>{serial}</p>
                        ))}
                    </div>
                  </div>
                )
            )
        ) : (
          <Empty style={{marginTop: '20px'}} description='Sản phẩm chưa có mã Serial!' />
        )}
      </div>
    </div>
  );
};

export default QuestionAnswer;
